import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,
    type: null,
    item: null
  },
  mutations: {
    INIT_CHANGES_ACTION_DIALOG(state, payload) {
      state.visibility = true
      state.type = payload.type
      state.item = payload.item
    },
    SET_CHANGES_ACTION_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_CHANGES_ACTION_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.type = null
        state.item = null
      }, 100)
    }
  },
  actions: {
    async submitChanges({ rootState, commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.submitting'), loading: true })
        commit('SET_CHANGES_ACTION_DIALOG_SUBMIT_BTN_DISABLE', true)
        let device_id = rootState.auth.selected_device
        const response = await api.submitChanges({ params: { device_id: device_id } })

        if (response.data.success) {
          commit('RESET_CHANGES_ACTION_DIALOG')
          commit('RESET_CHANGES_APPROVAL_DIALOG')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.submit'), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CHANGES_ACTION_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
